import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Images from '~/assets/images'
import { SET_USER_PROFILE_LOCATION } from '~/redux/actions'
import { DashboardBerthingManagementAPI } from '~/api'

const useHooks = () => {
  const dispatch = useDispatch()

  const appSize = useSelector((state) => state.appReducer)
  const { Location } = useSelector((state) => state.usersProfileReducer)
  const { UserLocations } = useSelector((state) => state.usersLoginReducer)

  const appHeight = appSize.height - 110 > 455 ? appSize.height - 110 : 455
  const viewPerPage = 4 // Number of items per page
  const refreshInterval = 15 // in minutes

  const [skip, setSkip] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [totalData, setTotalData] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const [dataBerthing, setDataBerthing] = useState([])

  const handleSetLocation = (value) => {
    const valueLocation = UserLocations.find((e) => e.LocationDescription === value)

    dispatch({
      type: SET_USER_PROFILE_LOCATION,
      payload: valueLocation,
    })
  }

  const mapGridTemplateColumns = (length) => {
    if (length === 3) {
      return 'repeat(3, 1fr)'
    } else if (length >= 2) {
      return 'repeat(2, 1fr)'
    } else {
      return '1fr'
    }
  }

  const mapBerthingManagementImage = (berthing) => {
    if (berthing) {
      const [name] = berthing.split('|')
      switch (name) {
        case 'Time':
          return Images.BerthingManagementTime
        case 'Vessel':
          return Images.BerthingManagementVessel
        case 'Process':
          return Images.BerthingManagementProcess
        case 'Berthing':
          return Images.BerthingManagementBerthing
        case 'Document':
          return Images.BerthingManagementDocument
        case 'Transferring':
          return Images.BerthingManagementTransferring
        default:
          return Images.BerthingManagementVessel
      }
    }
    return Images.BerthingManagementVessel
  }
  const handleChangeNext = () => {
    const newPage = Math.min(Math.ceil(totalData / viewPerPage), pageNumber + 1)
    setSkip((newPage - 1) * viewPerPage)
    setPageNumber(newPage)
  }

  const handleChangePrevious = () => {
    const newPage = Math.max(1, pageNumber - 1)
    setSkip((newPage - 1) * viewPerPage)
    setPageNumber(newPage)
  }

  const fetchBerthingManagement = async () => {
    setIsLoading(true)
    try {
      const payload = {
        skip: skip,
        take: viewPerPage,
        filters: Location && Location.LocationID
          ? `[{ "type": "number", "value": "${Location.LocationID}", "field": "location_code" }]`
          : '[]',
      }

      const response = await DashboardBerthingManagementAPI.GetDashboardBerthingManagement(payload)

      if (response.data && response.data.length > 0) {
        const mapDataBerthing = response.data.map((item) => ({
          ...item,
          activity: item.activity.map((activity) => ({
            ...activity,
            is_expanded: false,
            vessel_icon: mapBerthingManagementImage(activity.vessel_icon),
          })),
        }))
        setTotalData(response.count || 0)
        setDataBerthing(mapDataBerthing)
        setIsLoading(false)
      } else {
        throw new Error('No data found')
      }
    } catch (error) {
      setTotalData(0)
      setDataBerthing([])
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchBerthingManagement()
  }, [Location, skip])

  useEffect(() => {
    const intervalId = setInterval(()=>{
      fetchBerthingManagement()
    }, refreshInterval * 60 * 1000)
    return () => clearInterval(intervalId)
  }, [refreshInterval])

  const handleToggleExpand = (id) => {
    setDataBerthing((prevData) =>
      prevData.map((item) => ({
        ...item,
        activity: item.activity.map((activity) => ({
          ...activity,
          // Toggle expand for the clicked activity only
          is_expanded: activity.id === id ? !activity.is_expanded : false,
        })),
      }))
    )
  }

  return {
    data: {
      skip,
      isLoading,
      appHeight,
      totalData,
      pageNumber,
      viewPerPage,
      dataBerthing,
    },
    methods: {
      handleChangeNext,
      handleSetLocation,
      handleToggleExpand,
      handleChangePrevious,
      mapGridTemplateColumns,
    }
  }
}

export default useHooks